<div class="app-layout">
  <div class="app-shell">
    <app-sidebar *ngIf="!isNoSidebarRoute()"></app-sidebar>
    <main class="app-main" [class.auth-route]="isAuthRoute()">
      <router-outlet />
    </main>
  </div>
  <app-footer *ngIf="!isChatHistoryRoute()"></app-footer>
</div>
